<template>
    <div class="container">
        <div class="meet-level trans">
            <meet-header
                :headerConfig="headerConfig"
                @handleClickIocn="handleClickIocn"
            />

            <div class="main">
                <h2 class="tit">会务安排</h2>
                <!-- <div class="meet-notice-list" v-for="(item,i) in informList" :key="i">
                    <div @click="handleDetails(item)" class="item shadow"><span class="notice-tit">{{item.name}}</span><span class="time">查看详情</span></div>    
                </div> -->
                <div class="meet-notice-list">      
                    <!-- <div @click="handleDetails('jbap')" class="item shadow"><span class="notice-tit">接驳安排</span><span class="time">查看详情</span></div> -->
                     <div @click="handleDetails('ycap')" class="item shadow"><span class="notice-tit">用餐安排</span><span class="time">查看详情</span></div>    
                    <div @click="handleDetails('lxwm')" class="item shadow"><span class="notice-tit">联系我们</span><span class="time">查看详情</span></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import meetHeader from "@/components/header";

export default {
    name: "meetLevel",
    components: {
        meetHeader,
    },
    data() {
        return {
            headerConfig: {
                headerIcon: "city ct-xiangyou",
                headerTitle: "会议概况信息",
            },
            noticelist:[]
        };

    },
    created(){
        this.noticelist = this.$route.params.noticelist
    },
    methods: {
        handleClickIocn() {
            history.go(-1);
        },
        handleDetails(param){ 
                //取消接驳安排
                /*  if(param == 'jbap'){
                        this.$router.push({ name: "transhipdetail"})
                    }*/
                    if(param == 'ycap'){
                        this.$router.push({ name: "diningdetail"})
                    }
                    if(param == 'lxwm'){
                        this.$router.push({ name: "linkdetail"})
                    }        
                 
        }
    },
};
</script>

<style lang="scss" scoped>
.main {
    width: 100%;
    padding: 0 15px;
    margin-bottom: 30px;
    box-sizing: border-box;

    .tit {
        padding-left: 8px;
        margin-top: 30px;
        border-left: 4px solid var(--main-color);
        font-size: 18px;
        font-weight: bold;
        color: var(--main-color);
    }

   
    .meet-notice-list {
        width: 100%;
        margin-top: 30px;

        .item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px;
            height: 30px;
            border-radius: 5px;
            margin-bottom: 15px;

            &:last-child {
                margin-bottom: 0;
            }

            .notice-tit {
                font-size: 14px;
            }

            .time {
                font-size: 12px;
            }
        }
    }
}
</style>